import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';
import React from 'react';

export const SupplierIcon = ({ width = 22, height = 22, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;

  return (
    <svg width={width} height={height} viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.2201 14.8831L15.9623 14.1634L14.1632 13.4438V12.2554C14.8653 11.7291 15.3238 10.8173 15.4821 9.37887L15.734 6.38336C16.0398 3.81964 13.575 3.00105 12.2977 3.00105H11.722C10.2647 3.00105 9.8329 3.72968 9.8329 4.01754C9.25719 4.01754 8.09677 4.67422 8.2407 6.19446L8.52855 9.38786C8.68641 10.8223 9.14799 11.7331 9.84537 12.26V13.4438L8.04627 14.1634L5.77941 14.8831C4.60999 15.2519 3.75541 16.2504 3.56651 17.4648L3.00879 21H20.9907L20.433 17.4648C20.2441 16.2504 19.3896 15.2519 18.2201 14.8831Z'
        fill='white'
      />
      <path
        d='M15.9623 17.4018C13.3536 16.8261 12.8678 14.9101 12.8678 14.9101L11.1317 14.9101C11.1317 14.9101 10.655 16.8261 8.04627 17.4018V14.1634L5.77941 14.8831C4.60999 15.2519 3.75541 16.2504 3.56651 17.4648L3.00879 21L20.9907 21L20.433 17.4648C20.2441 16.2504 19.3896 15.2519 18.2201 14.8831L15.9623 14.1634V17.4018Z'
        fill={hovered ? fill : 'none'}
      />
      <path
        d='M10.5469 21C10.5469 19.8396 11.2845 17.042 11.2845 17.042C10.4119 16.1694 11.1316 14.91 11.1316 14.91C11.1316 14.91 12.0042 15.1979 12.8677 14.91C12.8677 14.91 13.5963 16.1694 12.7238 17.042C12.7238 17.042 13.4524 19.8396 13.4524 21'
        fill='white'
      />
      <path
        d='M10.5469 21C10.5469 19.8396 11.2845 17.042 11.2845 17.042C10.4119 16.1694 11.1316 14.91 11.1316 14.91C11.1316 14.91 12.0042 15.1979 12.8677 14.91C12.8677 14.91 13.5963 16.1694 12.7238 17.042C12.7238 17.042 13.4524 19.8396 13.4524 21'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.84537 12.2654V13.4438C9.84537 13.4438 9.97131 14.6222 11.1317 14.91C11.1317 14.91 10.655 16.8261 8.04627 17.4018V14.1634L5.77941 14.8831C4.60999 15.2519 3.75541 16.2504 3.56651 17.4648L3.00879 21'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.163 12.2564C14.163 12.8141 14.163 13.4438 14.163 13.4438C14.163 13.4438 14.0281 14.6222 12.8677 14.91C12.8677 14.91 13.3534 16.8261 15.9621 17.4018V14.1634L18.22 14.8831C19.3894 15.2519 20.244 16.2504 20.4329 17.4648L20.9906 21'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.547 12.6432C9.44951 12.2474 8.72086 11.2669 8.51397 9.3868L8.22612 6.1934C8.08219 4.67316 9.2426 4.01648 9.81832 4.01648C9.81832 3.72863 10.2501 3 11.7074 3H12.2831C13.5605 3 16.0252 3.81859 15.7194 6.38231L15.4675 9.37781C15.2606 11.2579 14.5409 12.2384 13.4345 12.6342'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.835 5.33884C10.835 5.33884 11.7075 7.38081 15.6655 7.07496'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.97103 6.49925C9.97103 6.49925 9.52126 7.60569 8.36084 7.60569'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
